import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DesiredCreditLimitComponent } from './components/desired-credit-limit/desired-credit-limit.component';
import { CardInfoComponent } from './components/card-info/card-info.component';
import { CardRecommendationComponent } from './components/card-recommendation/card-recommendation.component';
import { RecommendationComponent } from './components/recommendation/recommendation.component';


const routes: Routes = [ 
  { path: 'cardinfo', component: CardInfoComponent },
  { path: 'desiredCreditLimit', component: DesiredCreditLimitComponent },
  {
    path: 'recommendation',
    component: RecommendationComponent//,
   // resolve: { resolvedData: JsonResolver },
  },
  { path: 'cardrecommendation', component: CardRecommendationComponent },
  { path: '', redirectTo: 'recommendation', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
